module.exports = __webpack_public_path__ + "static/media/eye.7f849fcd.png";